import { type FC, useState } from 'react';
import WeWorkLogin from './wework-login';
import FeishuLogin from './feishu-login';
import QrloginSwitcher from 'src/components/qrlogin-switcher';
import { getPreferredQrPlatform } from 'src/common/client-platform';
import Container from './container';
import { getLoginTypeList } from 'src/api/api';
import useResource from 'src/hooks/use-resource';

export interface ScanLoginRootProps {
  title: string;
}

const ScanLoginRoot: FC<ScanLoginRootProps> = ({ title }) => {
  const [platform, setPlatform] = useState<"wework" | "feishu">(
    () => getPreferredQrPlatform()
  );
  const { data: list = [], loading } = useResource(getLoginTypeList);
  
  const hasFeishu = list.some(
    (it) => it.name.includes("飞书") || it.name.toLowerCase().includes("feishu")
  ) || true;

  const hasWework = true;
  const scanMethodsCount = (hasWework ? 1 : 0) + (hasFeishu ? 1 : 0);
  const showSwitcher = scanMethodsCount > 1;

  const activePlatform = (!loading && !hasFeishu) ? "wework" : platform;

  return (
    <Container title={title}>
      <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
        <QrloginSwitcher
          platform={activePlatform}
          onChange={setPlatform}
          showSwitcher={showSwitcher}
        >
          {activePlatform === "wework" ? (
            <WeWorkLogin />
          ) : (
            <FeishuLogin />
          )}
        </QrloginSwitcher>
      </div>
    </Container>
  );
};

export default ScanLoginRoot;
